import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from 'web/components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';
import axioPath from 'api/axioPath';
import AlertModal from 'web/components/AlertModal';
import { pickupOrderTableHeader } from '../Constants'

function PickupOrderReport({ downloadPickupOrderReportCSV, isDownloadingPickupOrderReportCSV }) {
    let history = useHistory();
    let location = useLocation();
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [finalData, setFinalData] = useState([])
    const [searching, setSearching] = useState("");
    const [searchKey, setSearchKey] = useState("");
    const [searchKeyTimeout, setSearchKeyTimeout] = useState(null);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState({});

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            let filterDataTemp = location.state.filter
            setFilterData(location.state.filter)
            dispatch(showAppLoader());
            const token = localStorage.getItem("token")
            let url = `order/v2/admin/pickup/get_order_list`
            let data = {
                size: 10,
                number: page - 1 ?? 0,
                sort: "ASC",
                companyName: filterDataTemp?.companyName,
                state: filterDataTemp?.state,
                city: filterDataTemp?.city,
                orderStatus: filterDataTemp?.status.map(data => data.value),
                fromDate: moment(filterDataTemp?.fromDate).format('YYYY/MM/DD'),
                toDate: moment(filterDataTemp?.toDate).format('YYYY/MM/DD'),
                searchBy: searchKey
            }
            axioPath.post(url, data, {
                headers: {
                    Authorization: token,
                    UserType: 'external'
                },
            }).then((response) => {
                if (response.data.success) {
                    if (response.data?.data?.pickupOrderList) {
                        let userSubList = response.data?.data?.pickupOrderList
                        setFinalData(userSubList)
                        setPageCount(response.data?.data?.totalPages ?? 1)
                    }
                } else {
                    setModalContent(response.data.message || 'Something went wrong, please try again in sometime.')
                    setModal(!modal)
                }
            }).catch((ex) => {
                if (ex.response?.status === 401) {
                    history.push('./sign-in')
                    window.location.reload(false)
                } else {
                    setModalContent(ex.response?.data?.message || ex.message)
                    setModal(!modal)
                }
            }).finally(() => {
                dispatch(hideAppLoader());
            })
        } else {
            history.push({
                pathname: '/reports',
                state: { page: 'pickupOrder' }
            })
        }
    }, [page, searchKey]);

    const handleChange = (event, value) => setPage(value)

    const handleSearchChangeFromService = (e) => {
        let searchVal = e.target.value
        setSearching(searchVal)
        if (searchKeyTimeout) clearTimeout(searchKeyTimeout)
        const t = setTimeout(() => setSearchKey(searchVal), 1000)
        setSearchKeyTimeout(t)
        setPage(1)
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                        state: { page: 'pickupOrder' }
                    })
                }} />
            <Header>
                <h3>Pickup Order Report</h3>
                <div className='action-wrapper'>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={searching}
                            onChange={handleSearchChangeFromService} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                    <button
                        disabled={isDownloadingPickupOrderReportCSV}
                        onClick={() => downloadPickupOrderReportCSV(filterData, 1, searchKey)}
                        style={{ background: isDownloadingPickupOrderReportCSV ? '#b2afac' : '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px' }}>
                        {isDownloadingPickupOrderReportCSV ? "Exporting..." : "Export"}
                    </button>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {pickupOrderTableHeader.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.orderId}</td>
                                    <td>{items.poNumber ? items.poNumber : 'NA'}</td>
                                    <td>{items.ptplusRefNumber}</td>
                                    <td>{items.pickupLocation?.locationName}</td>
                                    <td>{items.pickupLocation?.city}</td>
                                    <td>{items.pickupLocation?.state}</td>
                                    <td>{items.pickupLocation?.zipCode}</td>
                                    <td>{items.buyerInfo.locationName}</td>
                                    <td>{items.buyerInfo.city}</td>
                                    <td>{items.buyerInfo.state}</td>
                                    <td>{items.buyerInfo?.zipCode}</td>
                                    <td>{items.sellerInfo.locationName}</td>
                                    <td>{items.sellerInfo.city}</td>
                                    <td>{items.sellerInfo.state}</td>
                                    <td>{items.sellerInfo?.zipCode}</td>
                                    <td>{items.requestedPickupDate ? moment(items.requestedPickupDate).format("MM/DD/YYYY") : 'NA'}</td>
                                    <td>{items?.actualPickupDate ? moment(items?.actualPickupDate).format("MM/DD/YYYY") : 'NA'}</td>
                                    <td>{items?.quantity}</td>
                                    <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                                </tr>
                            ))}
                        {finalData.length === 0 &&
                            <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {pageCount > 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}
            <AlertModal
                isOpen={modal}
                toggle={() => setModal(!modal)}
                title=''
                content={modalContent}
            />
        </TableWrapper>
    )
};

export default PickupOrderReport;